import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'

// components
import AppCard from 'src/components/AppCard'
import AppCardHeader from 'src/components/card/AppCardHeader'
import AppDetails from 'src/components/details/product-details/AppDetails'
import AppVariantDetails from 'src/components/details/product-details/AppVariantDetails'
import AppCombinationDetails from 'src/components/details/product-details/AppCombinationDetails'
import AppModalConfirmation from 'src/components/modal/AppModalConfirmation'

// helpers
import Axios from 'src/helpers/axios'

const ProductDetails = () => {
  const navigate = useNavigate()
  const params = useParams()
  const { id } = params

  const [productDetails, setProductDetails] = useState('')

  const [showConfirmDelete, setShowConfirmDelete] = useState({ show: false, item: {} })

  const handleCardHeaderButton = () => {
    navigate(`/products/edit/${id}`)
    window.location.reload();
  }

  useEffect(() => {
    fetchProductDetails()
  }, [id]);

  const fetchProductDetails = () => {
    Axios({
      method: "get",
      url: `/api/ecommerce/v1/products/id/${id}`,
    })
      .then(({ data }) => {
        setProductDetails(data)
      })
      .catch((err) => {
        console.error(err);
      });
  }

  const handleDeleteConfirmation = (item) => {
    Axios({
      method: "delete",
      url: `/api/ecommerce/v1/products/delete/${item.id}`,
    })
      .then(({ data }) => {
        setShowConfirmDelete({ show: false, item: {} })
        navigate(`/products/list`)
      })
      .catch((err) => {
        console.error(err);
      });
  }

  return (
    <>
      {showConfirmDelete.show && (
        <AppModalConfirmation
          confirmationType='delete-item'
          itemName='product'
          itemDetails={showConfirmDelete.item}
          showModal={showConfirmDelete}
          setShowModal={setShowConfirmDelete}
          handleConfirmation={handleDeleteConfirmation}
        />
      )}
      <AppCard
        className='mt-4 mb-4'
        headerTitle={
          <AppCardHeader
            id={id}
            headerDeleteButton={true}
            setShowConfirmDelete={setShowConfirmDelete}
            headerTitle={<h4>Product Details</h4>}
            headerButton="Edit"
            handleCardHeaderButton={handleCardHeaderButton}
          />
        }
        bodyContent={
          <AppDetails
            productDetails={productDetails}
          />
        }
        lowerBodyContent={
          <>
            {productDetails?.variants?.length > 0 && (
              <AppCard
                className='mt-4 mb-4'
                headerTitle={<h5>Product Variants</h5>}
                bodyContent={
                  <AppVariantDetails
                    productVariants={productDetails?.variants}
                  />
                }
              />
            )}
            {productDetails?.combinations?.length > 0 && (
              <AppCard
                className='mt-4 mb-4'
                headerTitle={<h5>Product Combinations</h5>}
                bodyContent={
                  <AppCombinationDetails
                    productCombinations={productDetails?.combinations}
                  />
                }
              />
            )}
          </>
        }
      />
    </>
  )
}

export default ProductDetails
